module.exports = __webpack_public_path__ + "static/4gde-89f2be5055de1e7c66c42e68422a1437.gif";